import { useEffect, useState } from 'react'
import { getCachedImage } from '../utils'

const VNCachedImage = ({ imageKey, className, alt, onSuccess = () => {}, onError = () => {} }) => {
  const [image, setImage] = useState(null)

  useEffect(() => {
    getCachedImage(imageKey)
      .then((cachedImage) => {
        setImage(cachedImage)

        if (cachedImage) {
          onSuccess()
          return
        }

        onError()
      })
      .catch(() => {
        onError()
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageKey])

  if (!image) {
    return null
  }

  return <img alt={alt} className={className} src={image} />
}

export default VNCachedImage
